exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note[data-v-178b7328]{font-weight:400;font-size:smaller}.option[data-v-178b7328]{margin-top:-35px;margin-left:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-178b7328","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UseVouchers.vue
// module id = c++t
// module chunks = 0